// extracted by mini-css-extract-plugin
export var description = "style-module--description--3c3e1";
export var embeddedCta = "style-module--embedded-cta--3f7dc";
export var noPaddingMobile = "style-module--no-padding-mobile--6d3e3";
export var noXPaddingMobile = "style-module--no-x-padding-mobile--cfd54";
export var title = "style-module--title--f2f8f";
export var titleWithDescription = "style-module--title-with-description--b4d55";
export var topMargin = "style-module--top-margin--35ed7";
export var wrapper = "style-module--wrapper--6223a";